import { useGlobalStore } from '../stores/global';
import { load as initCaptcha }  from 'recaptcha-v3';

export async function getReCaptchaToken(action: string) {
    const store = useGlobalStore();
    const recaptcha = await initCaptcha(store.recaptcha);
    const token = await recaptcha.execute(action);

    return token;
}